import { useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, Plus } from "lucide-react";
import { fmtDate, humanize } from "@/lib/api";
import { useWsQuery } from "@/context/WorkspaceContext";
import { DemoBadge, EmptyState, PageHeader, QueryState, StatusBadge } from "@/components/common";

const STAGES = ["all", "interpreted", "draft", "pending_approval", "changes_requested", "strategy_approved", "cancelled"];

export default function Campaigns() {
  const q = useWsQuery("/campaigns");
  const [stage, setStage] = useState("all");
  return (
    <div>
      <PageHeader eyebrow="Plan" title="Campaigns" description="Every campaign starts as a command, becomes an editable strategy, and only moves forward with your approval."
        actions={<Link to="/command-centre?new=1" data-testid="campaigns-new-button" className="cq-btn cq-btn-primary"><Plus size={14} /> New campaign</Link>} />
      <div className="flex flex-wrap gap-2 mb-6">
        {STAGES.map((s) => <button key={s} data-testid={`campaign-filter-${s}`} onClick={() => setStage(s)} className={`px-3 py-1.5 rounded-lg text-xs border ${stage === s ? "border-[#22E6F2]/50 text-[#22E6F2] bg-[#22E6F2]/10" : "border-[#243153] text-[#AAB6CC] hover:text-[#F7FAFF]"}`}>{s === "all" ? "All" : humanize(s)}</button>)}
      </div>
      <QueryState q={q} empty={<EmptyState icon={Megaphone} title="No campaigns yet" description="Describe an outcome in the Command Centre to draft one." action={<Link to="/command-centre?new=1" className="cq-btn cq-btn-primary">Open Command Centre</Link>} />}>
        {(items) => {
          const list = items.filter((c) => stage === "all" || c.status === stage);
          if (!list.length) return <EmptyState title="No campaigns in this stage" />;
          return (
            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="campaign-list">
              {list.map((c) => (
                <Link key={c.id} to={`/campaigns/${c.id}`} data-testid={`campaign-card-${c.id}`} className="cq-card cq-card-hover p-6 flex flex-col">
                  <div className="flex items-center justify-between gap-2"><StatusBadge status={c.status} />{c.is_demo && <DemoBadge label="Demo" />}</div>
                  <h3 className="mt-4 font-display text-lg font-medium text-[#F7FAFF]">{c.name}</h3>
                  <p className="mt-2 text-sm text-[#AAB6CC] line-clamp-3 flex-1">{c.strategy?.executive_summary || c.interpretation?.business_objective}</p>
                  <div className="mt-5 pt-4 border-t border-[#172342] flex items-center justify-between text-[11px] text-[#7C8BAD]">
                    <span>{(c.strategy?.channel_mix || []).map((x) => x.channel).slice(0, 3).join(" · ") || c.interpretation?.market}</span><span>Updated {fmtDate(c.updated_at)}</span>
                  </div>
                </Link>))}
            </div>);
        }}
      </QueryState>
    </div>
  );
}
